var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"start-trading"},[_c('span',{staticClass:"state-layer label__large"},[_vm._v(" "+_vm._s(_vm.tokens.fullScreen.startTrading)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }